import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';

const ServiceNotesModal = ({ isOpen, onClose, notes, title, language = 'pt-BR' }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[350px] sm:max-h-[none] p-0 flex flex-col">
        <DialogHeader className="p-4 border-b flex-shrink-0 bg-white">
          <DialogTitle className="text-lg sm:text-xl font-bold text-emerald-800 flex items-center gap-2">
            📝 {language === 'pt-BR' ? 'Notas do Serviço' : 'Service Notes'}
          </DialogTitle>
          {title && (
            <p className="text-xs sm:text-sm text-gray-600 mt-2">{title}</p>
          )}
        </DialogHeader>

        <div 
          className="flex-1 overflow-y-auto p-4 bg-gray-50 min-h-0"
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          <div className="whitespace-pre-wrap text-sm text-gray-800">
            {notes || (language === 'pt-BR' ? 'Sem notas disponíveis' : 'No notes available')}
          </div>
        </div>

        <DialogFooter className="p-4 border-t flex-shrink-0 bg-white">
          <Button onClick={onClose} className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700">
            {language === 'pt-BR' ? 'Fechar' : 'Close'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceNotesModal;
